import axios from 'axios'
// axios 配置
axios.defaults.timeout = 5000
axios.defaults.baseURL = 'http://121.40.191.9'
// axios.defaults.baseURL = 'http://47.98.146.185'
// axios.defaults.baseURL = 'http://192.168.2.88:8080'

// http request 拦截器
axios.interceptors.request.use()

// http response 拦截器
axios.interceptors.response.use(
  response => {
    switch (response.data.status) {
      case 301:
        // 返回 301 清除token信息并跳转到登录页面
        // sessionStorage.removeItem('user')
        // window.loacation.reload()
        // Vue.$store.commit(types.LOGOUT)
        // router.replace({
        //   path: 'login',
        //   query: { redirect: router.currentRoute.fullPath }
        // })
        break
      default:
        return response // 返回接口返回的错误信息s
    }
  },
  error => {
    return Promise.reject(error) // 返回接口返回的错误信息
  })
export default axios


// WEBPACK FOOTER //
// ./src/assets/js/http.js